/**
 * watchlist-entry.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AbstractControl } from "@angular/forms";
import { TypedDataHolder } from "../common/data/typed-data";
import { SubjectContextType } from "../subjects/subject-context-type";
// import { SubjectReference } from "../subjects/subject-reference";
import { Displayable } from "../support/types/aliases";
import { SharedList } from "./watchlist.service";

export class WatchlistEntry
{
  public alert : boolean;
  public watchId : number;
  public summary : Array<TypedDataHolder & Displayable>;
  public note : string;
  public emailNotifyOnUpdate : boolean;
  public lastObserved : number;
  public contextType : SubjectContextType;
  public categories : string[];
  public parent? : SharedList;

  public control? : AbstractControl;

  public static startTable (entry : WatchlistEntry) : WatchlistTable
  {
    return {
      columns : entry.summary.map((col : Displayable) => col.displayName),
      contextType : entry.contextType,
      entries : [entry]
    };
  }

  // public get id () : number
  // {
  //   return this.watchId;
  // }
}

export interface WatchlistTable {
  columns : string[];
  contextType : SubjectContextType;
  entries : WatchlistEntry[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/watchlist/watchlist-entry.ts